import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Divider, Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { ORDERS, PAYOUT } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
const _ = require('lodash');

const PendingPayout = (props) => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('asc');
   const [orderBy, setOrderBy] = useState('name');
   const axiosPrivate = useAxiosPrivate();
   const [showImage, setShowImage] = useState();
   const [filterName, setFilterName] = useState('');
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loading, setLoding] = useState(true);
   const [totalPendingPayout, setTotalPendingPayout] = useState();
   const [walletAmount, setWalletAmount] = useState();
   const [totalEarning, setTotalEarning] = useState();
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const [openModal, setOpenModal] = useState(false);
   const [orders, setOrders] = useState([]);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'createdAt', label: 'Date & Time', alignRight: false },
      { id: 'user_name', label: 'Total Amount', alignRight: false },
      { id: 'email', label: 'Total Charge', alignRight: false },
      { id: 'order_number', label: 'Payout Amount', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   const ORDER_TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'order_id', label: 'Order Id', alignRight: false },
      { id: 'order amount', label: 'Order amount', alignRight: false },
      // { id: 'payment_type', label: 'Payment Type', alignRight: false },
   ];

   const EVENT_TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'user_name', label: 'Event Name', alignRight: false },
      { id: 'amount', label: 'Amount', alignRight: false },
      { id: 'no_of_people', label: 'No. Of Pepole', alignRight: false },
      { id: 'booking_id', label: 'Booking Id', alignRight: false },
      // { id: 'payment_type', label: 'Payment Type', alignRight: false }
   ];

   const NGO_TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'title', label: 'NGO Title', alignRight: false },
      { id: 'amount', label: 'Amount', alignRight: false },
      { id: 'donation_id', label: 'Donation Id', alignRight: false },
      // { id: 'payment_type', label: 'Payment Type', alignRight: false }
   ];

   async function getPendingPayout(page, filterName) {
      const response = await axiosPrivate.get(PAYOUT.getMyPayout, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      setWalletAmount(response.data.wallet_amount);
      setTotalPendingPayout(response.data.pending_payout)
      setTotalEarning(response.data.total_earning)
      return response.data.transactionList[0];
   }

   const { data: pendingPayoutList, refetch } = useQuery(['pendingPayoutList', page, filterName], () => getPendingPayout(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (pendingPayoutList) {
         setTableData(pendingPayoutList.data);
         setRowsPerPage(pendingPayoutList?.metadata.length != 0 ? pendingPayoutList?.metadata[0].limit : 10);
      }
      if (pendingPayoutList?.metadata.length != 0 && pendingPayoutList?.metadata[0].hasMoreData == true) {
         getPendingPayout(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [pendingPayoutList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getPendingPayout(page, filterName)
      refetch();
   };

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteOrder = async () => {
      const response = await axiosPrivate.delete(ORDERS.deleteOrder + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Order delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = async (data) => {
      setOpenModal(true);
      const response = await axiosPrivate.get(PAYOUT.getOrders, { params: { _id: data._id, category_type: props?.userData?.category_type } })
      setOrders(response?.data)
   };

   const handleCloseModal = () => {
      setOpenModal(false);
   };

   const formatCount = (count) => {
      // function done by shreya
      const COUNT_ABBRS = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
      const decimals = 2;

      const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
      let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
      result += `${COUNT_ABBRS[i]}`;
      let value = count;
      if (count >= 1000) {
         value = result;
      }
      return value;
   };

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
            <div className="col">
               <div className="card text-center  dashboard_card">
                  <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                     Pending Payment
                  </div>
                  <div className="card_content">
                     <Stack spacing={2}>
                        <span className="app_text_30_500 app_text_black_3">£{formatCount(totalPendingPayout?.toFixed(2))}</span>
                     </Stack>
                  </div>
               </div>
            </div>
            <div className="col">
               <div className="card text-center  dashboard_card">
                  <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                     Confirmed Payment
                  </div>
                  <div className="card_content">
                     <Stack spacing={2}>
                        <span className="app_text_30_500 app_text_black_3">£{formatCount(totalEarning?.toFixed(2))}</span>
                     </Stack>
                  </div>
               </div>
            </div>
            <div className="col">
               <div className="card text-center  dashboard_card">
                  <div className="justify-content-evenly card-header app_text_14_bold app_text_black">
                     Wallet Amount
                  </div>
                  <div className="card_content">
                     <Stack spacing={2}>
                        <span className="app_text_30_500 app_text_black_3">£{formatCount(walletAmount?.toFixed(2))}</span>
                     </Stack>
                  </div>
               </div>
            </div>
         </div>
         <Divider sx={{ my: 5, borderBottom: '1.5px solid' }} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">My Payment</h4>
            <Paper component="form" className='dashboard_searchbox col-lg-4'>
               <IconButton>
                  <SearchIcon />
               </IconButton>
               <InputBase
                  fullWidth
                  sx={{ flex: 1 }}
                  placeholder="search ..."
                  onChange={(e) => handleFilterByName(e)}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
               />
            </Paper>
         </div>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={pendingPayoutList?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers?.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                 <TableCell component="th" scope="row"> £{row?.amount?.toFixed(2)} </TableCell>
                                 <TableCell align="left"> £{row?.deduction?.toFixed(2)} </TableCell>
                                 <TableCell align="left"> £{row?.payout_amount?.toFixed(2)} </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 1 ? <Chip variant="contained" className="app_status_chip pending" label="pending" /> : (row.status === 2) ? <Chip variant="contained" className="app_status_chip progress" label="progress" /> : <Chip variant="contained" className="app_status_chip accepted" label="Completed" />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       <Button title="Order Details" variant="text" className="user_list_row_btn" onClick={(e) => handleOpenModalAdd(row)} ><VisibilityIcon /></Button>
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={pendingPayoutList?.metadata.length != 0 ? pendingPayoutList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions className='m-auto'>
               <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                  cancel
               </Button>
               <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                  delete
               </Button>
            </DialogActions>
         </Dialog>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>
                     {props?.userData?.category_type === "5" ? "NGO" : (props?.userData?.category_type === "3") ? "Events" : "Orders"}
                  </h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>

            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2" sx={{ minWidth: '400px' }}>
               <Card>
                  <TableContainer>
                     {
                        props?.userData?.category_type === "5" ?
                           <>
                              <Table>
                                 <UserListHead
                                    headLabel={NGO_TABLE_HEAD}
                                    rowCount={pendingPayoutList?.data?.length}
                                    onRequestSort={handleRequestSort}
                                 />
                                 {orders?.length > 0 ?
                                    <TableBody>
                                       {orders.map((row) => {
                                          return (
                                             <StyledTableRow key={row._id}>
                                                <TableCell align="left"> {row?.user_data?.firstname ? row?.user_data?.firstname + ' ' + row?.user_data?.lastname : '-'} </TableCell>
                                                <TableCell component="th" scope="row"> {row?.user_data?.email ?? '-'} </TableCell>
                                                <TableCell component="th" scope="row"> {row?.user_data?.mobile ?? '-'} </TableCell>
                                                <TableCell component="th" scope="row"> {row?.ngo_data?.title ?? '-'} </TableCell>
                                                <TableCell component="th" scope="row"> £{row?.amount?.toFixed(2) ?? '-'} </TableCell>
                                                <TableCell component="th" scope="row"> {row?.donation_id ?? '-'} </TableCell>
                                                {/* <TableCell component="th" scope="row"> {row?.payment_type ?? '-'} </TableCell> */}
                                             </StyledTableRow>
                                          )
                                       })}
                                    </TableBody>
                                    :
                                    <TableBody>
                                       <TableRow>
                                          <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                             <span className="app_text_16_semibold">No Data Found</span>
                                          </TableCell>
                                       </TableRow>
                                    </TableBody>}
                              </Table>
                           </> :
                           (props?.userData?.category_type === "3") ?
                              <>
                                 <Table>
                                    <UserListHead
                                       headLabel={EVENT_TABLE_HEAD}
                                       rowCount={pendingPayoutList?.data?.length}
                                       onRequestSort={handleRequestSort}
                                    />
                                    {orders?.length > 0 ?
                                       <TableBody>
                                          {orders.map((row) => {
                                             return (
                                                <StyledTableRow key={row._id}>
                                                   <TableCell align="left"> {row?.user_data?.firstname ? row?.user_data?.firstname + ' ' + row?.user_data?.lastname : '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.user_data?.email ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.user_data?.mobile ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.user_name ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.amount ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.no_of_people ?? '-'} </TableCell>
                                                   {/* <TableCell component="th" scope="row"> {row?.payment_type ?? '-'} </TableCell> */}
                                                   <TableCell component="th" scope="row"> {row?.booking_id ?? '-'} </TableCell>
                                                </StyledTableRow>
                                             )
                                          })}
                                       </TableBody>
                                       :
                                       <TableBody>
                                          <TableRow>
                                             <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                                <span className="app_text_16_semibold">No Data Found</span>
                                             </TableCell>
                                          </TableRow>
                                       </TableBody>}
                                 </Table>
                              </> :
                              <>
                                 <Table>
                                    <UserListHead
                                       headLabel={ORDER_TABLE_HEAD}
                                       rowCount={pendingPayoutList?.data?.length}
                                       onRequestSort={handleRequestSort}
                                    />
                                    {orders?.length > 0 ?
                                       <TableBody>
                                          {orders.map((row) => {
                                             return (
                                                <StyledTableRow key={row._id}>
                                                   <TableCell align="left"> {row?.user_data?.firstname ? row?.user_data?.firstname + ' ' + row?.user_data?.lastname : '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.user_data?.email ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.user_data?.mobile ?? '-'} </TableCell>
                                                   <TableCell component="th" scope="row"> {row?.order_id ?? '-'} </TableCell>
                                                   <TableCell align="left"> £{row?.total_amount?.toFixed(2)} </TableCell>
                                                   {/* <TableCell component="th" scope="row"> {row?.payment_type ?? '-'} </TableCell> */}
                                                   {/* <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                       <TableCell component="th" scope="row"> £{row?.amount?.toFixed(2)} </TableCell>
                                       <TableCell align="left"> £{row?.deduction?.toFixed(2)} </TableCell>
                                       <TableCell>
                                          <Stack direction="row" spacing={3}>
                                             {
                                                row.status === 1 ? <Chip variant="contained" className="app_status_chip pending" label="pending" /> : (row.status === 2) ? <Chip variant="contained" className="app_status_chip progress" label="progress" /> : <Chip variant="contained" className="app_status_chip accepted" label="Completed" />
                                             }
                                          </Stack>
                                       </TableCell>
                                       <TableCell>
                                          <Stack direction="row" spacing={3}>
                                             <Button title="Order Details" variant="text" className="user_list_row_btn" onClick={(e) => handleOpenModalAdd(row)} ><VisibilityIcon /></Button>
                                          </Stack>
                                       </TableCell> */}
                                                </StyledTableRow>
                                             )
                                          })}
                                       </TableBody>
                                       :
                                       <TableBody>
                                          <TableRow>
                                             <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                                <span className="app_text_16_semibold">No Data Found</span>
                                             </TableCell>
                                          </TableRow>
                                       </TableBody>}
                                 </Table>
                              </>
                     }
                  </TableContainer>
               </Card>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default PendingPayout